import { ArrowLeft, Home, MapPin, Play, VolumeX } from "lucide-react";

import { useAudioCoordinator } from "../stores/audioCoordinator";
import { useNavigationStore } from "../stores/navigationStore";
import styles from "../styles/App.module.css";
import { CommandButton } from "./CommandButton";

type GlobalControlsProps = {
  where: string;
};

export function GlobalControls({ where }: GlobalControlsProps) {
  const stopAll = useAudioCoordinator((state) => state.stopAll);
  const announce = useAudioCoordinator((state) => state.announce);
  const resumePrepared = useAudioCoordinator((state) => state.resumePrepared);
  const audioStatus = useAudioCoordinator((state) => state.status);
  const back = useNavigationStore((state) => state.back);
  const home = useNavigationStore((state) => state.home);
  const route = useNavigationStore((state) => state.route);
  const isHomeRoute = route.name === "home";

  return (
    <nav className={styles.globalControls} aria-label="全局操作">
      <CommandButton
        icon={VolumeX}
        title="停止所有 App 声音"
        onClick={stopAll}
      />
      <CommandButton
        icon={MapPin}
        title="告诉我现在在哪"
        onClick={() => {
          announce(`你现在在：${where}。`);
        }}
      />
      {audioStatus === "ready_for_tap" ? (
        <CommandButton
          icon={Play}
          title="继续播放准备好的声音"
          hint="也可以双指双击播放或暂停"
          onClick={() => {
            void resumePrepared();
          }}
        />
      ) : null}
      <CommandButton
        icon={ArrowLeft}
        title="返回上一层"
        hint="页面末尾返回操作"
        onClick={back}
      />
      <CommandButton
        icon={Home}
        title={isHomeRoute ? "返回顶部" : "返回主菜单"}
        hint={isHomeRoute ? "回到主菜单第一项" : "返回后焦点到主菜单第一项"}
        onClick={() => {
          announce(isHomeRoute ? "已经回到主菜单顶部。" : "已返回主菜单。");
          home();
        }}
      />
    </nav>
  );
}
